import React, { Dispatch, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import specialdiscount from "../../assets/specialOffer.png";
import spdashboard from "../../assets/spdashboard.png";
import './SpecialOffers.css'
import { useDispatch, useSelector } from 'react-redux';
import { getSpecialOffers } from '../../store/actions/specialOffers.action';
import { get } from 'lodash';

const SpecialOffers: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const history = useHistory();

  useEffect(() => {
    dispatch(getSpecialOffers());
  }, [dispatch]);

  const { specialOffers }: any = useSelector(
    (state: any) => state.specialOffers
  );
  const { announcements }: any = useSelector((state: any) => state.announcements);

  const specialOffersUnavailable =
    (!announcements || !get(announcements, 'data.data.Offers.OffersList', []).some((offer: any) => offer.announcement_type === "offer_announcement"));


  // const specialOffersUnavailable =
  //     !specialOffers ||
  //     specialOffers?.data === null ||
  //     specialOffers?.data?.message === "Network Error";

  return (
    <>
      <h5 className="page-sub-title">Special Offers</h5>
      <div className="cardCommon height-400">
        {specialOffersUnavailable ?
          (
            <div className="d-flex justify-content-center align-items-center h-100">
              <img
                src={spdashboard}
                alt="No SpecialOffers"
                // onClick={(e) => { e.preventDefault(); history.push('/specialofferdetail'); }}
                style={{ height: "380px", width: "450px", overflow: "hidden" }}
              />
            </div>
          )
          : (
            <div className="col-12 mt-3">
              <img className="img-fluid-costom" src={specialdiscount} alt="special offer"
                onClick={(e) => { e.preventDefault(); history.push('/specialofferdetail'); }} />
            </div>
          )}
      </div>

    </>
  )
}

export default SpecialOffers
